var NavigationNestedDropdown, NavigationSubdivision, NavigationSubsection,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

NavigationNestedDropdown = (function($) {
  var activeClass;

  activeClass = 'open';

  function NavigationNestedDropdown(el) {
    this.$el = $(el);
    this.trigger = this.$el.find('[data-dropdown-trigger]:first');
    this.menu = this.$el.find('[data-dropdown-menu]:first');
    this.initTrigger();
  }

  NavigationNestedDropdown.prototype.initTrigger = function() {
    return this.trigger.click((function(_this) {
      return function(e) {
        e.preventDefault();
        if (_this.$el.hasClass(activeClass)) {
          _this.$el.find('[data-nav-nested-dropdown]').each(function(index, element) {
            return _this.close($(element));
          });
          return _this.close(_this.$el);
        } else {
          return _this.open();
        }
      };
    })(this));
  };

  NavigationNestedDropdown.prototype.open = function() {
    this.$el.addClass(activeClass);
    this.menu.css({
      display: 'block',
      height: 'auto'
    });
    this.menuHeight = this.menu.outerHeight();
    this.menu.css('height', 0);
    this.menu[0].dataset.open = "true";
    return this.menu.animate({
      height: this.menuHeight
    }, 200, (function(_this) {
      return function() {
        return _this.menu.css('height', 'auto');
      };
    })(this));
  };

  NavigationNestedDropdown.prototype.close = function($el) {
    var $menu;
    $menu = $el.find('[data-dropdown-menu]:first');
    $el.removeClass(activeClass);
    $menu[0].dataset.open = "false";
    return $menu.animate({
      height: 0
    }, 200);
  };

  return NavigationNestedDropdown;

})(jQuery);

NavigationSubdivision = (function($) {
  var activeClass;

  activeClass = 'active';

  function NavigationSubdivision(el) {
    this.triggerHandle = __bind(this.triggerHandle, this);
    this.$el = $(el);
    this.trigger = this.$el.find('[data-subdivision-trigger]');
    this.menu = this.$el.find('[data-subdivision-menu]');
    this.siblings = this.$el.siblings('[data-nav-subdivision]');
    this.outside = [this.trigger, this.menu, this.siblings];
    this.trigger.bind('click', this.triggerHandle);
    this.initHoverIntent();
  }

  NavigationSubdivision.prototype.initHoverIntent = function() {
    if (typeof this.trigger.hoverIntent === 'function') {
      return this.trigger.hoverIntent(this.triggerHandle);
    }
  };

  NavigationSubdivision.prototype.triggerHandle = function(e) {
    var $adjacentHeight, $adjacentMenu, $adjacentOpen;
    e.preventDefault();
    if (!this.$el.hasClass('active')) {
      $adjacentOpen = false;
      this.siblings.each((function() {
        if ($(this).hasClass(activeClass)) {
          return $adjacentOpen = $(this);
        }
      }));
      if ($adjacentOpen) {
        $adjacentMenu = $adjacentOpen.find('[data-subdivision-menu]');
        $adjacentHeight = $adjacentMenu.outerHeight();
        this.close($adjacentMenu);
        return this.open($adjacentHeight);
      } else {
        $('[data-nav-subdivision]').each((function(_this) {
          return function(i, element) {
            if ($(element).hasClass(activeClass)) {
              return _this.close($(element).find('[data-subdivision-menu]'));
            }
          };
        })(this));
        return this.open(0);
      }
    }
  };

  NavigationSubdivision.prototype.bindClose = function() {
    return $('body').mouseup((function(_this) {
      return function(e) {
        if (_this.outHide(e)) {
          return _this.close(_this.menu);
        }
      };
    })(this));
  };

  NavigationSubdivision.prototype.outHide = function(e) {
    var hit, o, _i, _len, _ref;
    hit = true;
    _ref = this.outside;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      o = _ref[_i];
      if ($(e.target).closest(o).length) {
        hit = false;
      }
    }
    return hit;
  };

  NavigationSubdivision.prototype.open = function(initHeight) {
    var $menuHeight;
    this.$el.addClass(activeClass);
    this.menu.css('display', 'block');
    $menuHeight = this.menu.outerHeight();
    this.menu.css('height', initHeight);
    return this.menu.animate({
      height: $menuHeight
    }, 250, (function(_this) {
      return function() {
        _this.trigger.bind('click', _this.triggerHandle);
        _this.initHoverIntent();
        return _this.bindClose();
      };
    })(this));
  };

  NavigationSubdivision.prototype.close = function(element) {
    return element.animate({
      opacity: 0
    }, 250, function() {
      $(this).parents('[data-nav-subdivision]').removeClass(activeClass);
      return $(this).css({
        opacity: 1,
        display: 'none'
      });
    });
  };

  return NavigationSubdivision;

})(jQuery);

NavigationSubsection = (function($) {
  var activeClass;

  activeClass = 'active';

  function NavigationSubsection(el) {
    this.$el = $(el);
    this.trigger = this.$el.find('[data-subsection-trigger]:first');
    this.innerMenu = this.$el.find('[data-subsection-menu]:first');
    this.menuContainer = this.$el.parents('[data-subdivision-menu]:first');
    this.siblings = this.$el.siblings('[data-nav-subsection]');
    this.trigger.click((function(_this) {
      return function(e) {
        e.preventDefault();
        _this.setMenuHeight();
        return _this.setActiveMenu();
      };
    })(this));
  }

  NavigationSubsection.prototype.setMenuHeight = function() {
    var $minHeight, $targetHeight;
    $minHeight = 0;
    this.$el.parents('[data-subsection-menu]').each(function() {
      var $menuHeight;
      $menuHeight = $(this).outerHeight();
      if ($menuHeight > $minHeight) {
        return $minHeight = $menuHeight;
      }
    });
    $minHeight += 56;
    $targetHeight = this.innerMenu.outerHeight() + 56;
    this.menuContainer.css('height', this.menuContainer.outerHeight());
    return this.menuContainer.animate({
      height: $targetHeight > $minHeight ? $targetHeight : $minHeight
    });
  };

  NavigationSubsection.prototype.setActiveMenu = function() {
    this.siblings.each((function(_this) {
      return function(i, element) {
        if ($(element).hasClass(activeClass)) {
          return $(element).removeClass(activeClass);
        }
      };
    })(this));
    return this.$el.addClass(activeClass);
  };

  return NavigationSubsection;

})(jQuery);

(function($) {
  $.fn.extend({
    navigationNestedDropdown: function(options) {
      return this.each(function() {
        return new NavigationNestedDropdown(this);
      });
    },
    navigationSubdivision: function(options) {
      return this.each(function() {
        return new NavigationSubdivision(this);
      });
    },
    navigationSubsection: function(options) {
      return this.each(function() {
        return new NavigationSubsection(this);
      });
    }
  });

  $('a[data-subsection-trigger]').each(function(i, el) {
    var $el;
    $el = $(el);
    return $el.next('ul').prepend($("<li><a href=\"" + ($el.attr('href')) + "\">" + ($el.text()) + "</a></li>"));
  });
  $('a[data-subdivision-header]').each(function(i, el) {
    var $el;
    $el = $(el);
    return $el.next('div').find('ul:eq(0)').prepend($("<li><a href=\"" + ($el.attr('href')) + "\">" + ($el.text()) + "</a></li>"));
  });
  return $('a[data-clone-overviews]').each(function(i, el) {
    var $el;
    $el = $(el);
    return $el.next('ul').prepend($("<li class=\"nav-subdivision-overview\"><a href=\"" + ($el.attr('href')) + "\">" + ($el.text()) + "</a></li>"));
  });
})(jQuery);
